import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { $ as $$1, append } from 'vscode/vscode/vs/base/browser/dom';
import { DisposableStore } from 'vscode/vscode/vs/base/common/lifecycle';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { IHoverService } from 'vscode/vscode/vs/platform/hover/browser/hover.service';
import 'vscode/vscode/vs/platform/list/browser/listService';
import { renderExpressionValue } from 'vscode/vscode/vs/workbench/contrib/debug/browser/baseDebugView';

var NotebookVariableRenderer_1;
const _moduleId = "vs/workbench/contrib/notebook/browser/contrib/notebookVariables/notebookVariablesTree";
const $ = $$1;
const MAX_VALUE_RENDER_LENGTH_IN_VIEWLET = 1024;
class NotebookVariablesDelegate {
    getHeight(element) {
        return 22;
    }
    getTemplateId(element) {
        return NotebookVariableRenderer.ID;
    }
}
let NotebookVariableRenderer = class NotebookVariableRenderer {
    static { NotebookVariableRenderer_1 = this; }
    static { this.ID = 'variableElement'; }
    get templateId() {
        return NotebookVariableRenderer_1.ID;
    }
    constructor(_hoverService) {
        this._hoverService = _hoverService;
    }
    renderTemplate(container) {
        const expression = append(container, $('.expression'));
        const name = append(expression, $('span.name'));
        const value = append(expression, $('span.value'));
        const template = { expression, name, value, elementDisposables: ( (new DisposableStore())) };
        return template;
    }
    renderElement(element, _index, data) {
        const text = element.element.value.trim() !== '' ? `${element.element.name}:` : element.element.name;
        data.name.textContent = text;
        data.name.title = element.element.type ?? '';
        renderExpressionValue(element.element, data.value, {
            colorize: true,
            hover: data.elementDisposables,
            maxValueLength: MAX_VALUE_RENDER_LENGTH_IN_VIEWLET
        }, this._hoverService);
    }
    disposeElement(element, index, templateData, height) {
        templateData.elementDisposables.clear();
    }
    disposeTemplate(templateData) {
        templateData.elementDisposables.dispose();
    }
};
NotebookVariableRenderer = NotebookVariableRenderer_1 = ( (__decorate([
    ( (__param(0, IHoverService)))
], NotebookVariableRenderer)));
class NotebookVariableAccessibilityProvider {
    getWidgetAriaLabel() {
        return ( localizeWithPath(_moduleId, 0, "Notebook Variables"));
    }
    getAriaLabel(element) {
        return ( localizeWithPath(_moduleId, 1, "Variable {0}, value {1}", element.name, element.value));
    }
}

export { NotebookVariableAccessibilityProvider, NotebookVariableRenderer, NotebookVariablesDelegate };
